import { Controller } from "@hotwired/stimulus"
import { customTooltips } from "@coreui/chartjs"
import { getStyle } from "@coreui/utils"
import Chart from "chart.js/auto"

export default class extends Controller {
  connect() {
    this.charts = []
    this.configureChartDefaults()
    this.createSalesChart()
    this.createTrafficChart()

    this.updateCharts = this.updateCharts.bind(this)
    document.documentElement.addEventListener("ColorSchemeChange", this.updateCharts)
    this.updateCharts()
  }

  disconnect() {
    document.documentElement.removeEventListener("ColorSchemeChange", this.updateCharts)
    this.charts.forEach((chart) => chart.destroy())
  }

  configureChartDefaults() {
    Chart.defaults.elements.point.hitRadius = 1
    Chart.defaults.plugins.tooltip.enabled = false
    Chart.defaults.plugins.tooltip.mode = "index"
    Chart.defaults.plugins.tooltip.position = "nearest"
    Chart.defaults.plugins.tooltip.external = customTooltips
    Chart.defaults.color = getStyle("--cui-body-color")
  }

  createSalesChart() {
    this.createChart("card-chart-new1", {
      type: "line",
      data: {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [
          {
            label: "My First dataset",
            backgroundColor: `rgba(${getStyle("--cui-primary-rgb")}, .1)`,
            borderColor: getStyle("--cui-primary"),
            borderWidth: 3,
            data: [78, 81, 80, 45, 34, 22, 40],
            fill: true,
          },
        ],
      },
      options: {
        plugins: { legend: { display: false } },
        maintainAspectRatio: false,
        scales: {
          x: { display: false },
          y: { beginAtZero: true, display: false },
        },
        elements: {
          line: { borderWidth: 2, tension: 0.4 },
          point: { radius: 0, hitRadius: 10, hoverRadius: 4 },
        },
      },
    })
  }

  createTrafficChart() {
    this.trafficChart = this.createChart("main-bar-chart", {
      type: "bar",
      data: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
          {
            label: "Users",
            backgroundColor: getStyle("--cui-primary"),
            borderRadius: 6,
            borderSkipped: false,
            data: [78, 81, 80, 45, 34, 12, 40, 85, 65, 23, 12, 98, 34, 84, 67, 82],
            barPercentage: 0.6,
            categoryPercentage: 0.5,
          },
          {
            label: "New users",
            backgroundColor: getStyle("--cui-gray-100"),
            borderRadius: 6,
            borderSkipped: false,
            data: [78, 81, 80, 45, 34, 12, 40, 85, 65, 23, 12, 98, 34, 84, 67, 82],
            barPercentage: 0.6,
            categoryPercentage: 0.5,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          x: {
            border: { display: false },
            grid: {
              color: getStyle("--cui-border-color-translucent"),
              display: false,
              drawTicks: false,
            },
            ticks: {
              color: getStyle("--cui-body-color"),
              font: { size: 14 },
              padding: 16,
            },
          },
          y: {
            beginAtZero: true,
            border: { dash: [2, 4], display: false },
            grid: { color: getStyle("--cui-border-color-translucent") },
            ticks: {
              color: getStyle("--cui-body-color"),
              font: { size: 14 },
              maxTicksLimit: 5,
              padding: 16,
              stepSize: Math.ceil(100 / 4),
            },
          },
        },
      },
    })
  }

  createChart(id, configuration) {
    const canvas = this.element.querySelector(`#${id}`)
    if (!canvas) return

    Chart.getChart(canvas)?.destroy()
    const chart = new Chart(canvas, configuration)
    this.charts.push(chart)
    return chart
  }

  updateCharts() {
    Chart.defaults.color = getStyle("--cui-body-color")
    if (!this.trafficChart) return

    const bodyColor = getStyle("--cui-body-color")
    const gridColor = getStyle("--cui-border-color-translucent")

    this.trafficChart.options.scales.x.ticks.color = bodyColor
    this.trafficChart.options.scales.y.ticks.color = bodyColor
    this.trafficChart.options.scales.x.grid.color = gridColor
    this.trafficChart.options.scales.y.grid.color = gridColor
    this.trafficChart.update()
  }
}
